import { createFileRoute, redirect } from "@tanstack/react-router";
import { getLocationBySlug } from "@/data/locations";
import { seo } from "@/lib/seo";
import LocationPage from "@/pages/locations/LocationPage";

// Western Wisconsin service areas were published briefly and then withdrawn.
// They were in the sitemap, so send anything that reaches them to the service
// area index with a permanent redirect rather than serving a soft 404.
const RETIRED_SLUGS = new Set([
  "hudson-wi",
  "river-falls-wi",
  "new-richmond-wi",
  "somerset-wi",
  "prescott-wi",
  "baldwin-wi",
  "roberts-wi",
  "ellsworth-wi",
]);

export const Route = createFileRoute("/_site/locations/$slug")({
  beforeLoad: ({ params }) => {
    if (RETIRED_SLUGS.has(params.slug)) {
      throw redirect({ to: "/locations", statusCode: 301 });
    }
  },
  head: ({ params }) => {
    const location = getLocationBySlug(params.slug);
    if (!location) return {};
    return seo({
      title: `Roofing & Exteriors in ${location.city} | Kodiak Structures & Exteriors`,
      description: `Expert roofing, siding, and exterior services in ${location.name}, Minnesota. Get a free estimate from Kodiak Structures & Exteriors today.`,
      path: `/locations/${location.slug}`,
      image: location.image ?? null,
    });
  },
  component: LocationPage,
});
